import React from 'react';
import { useLocation } from 'react-router-dom';
import '../styles/Sidebar.css';

const NavButton = ({ active, icon, label, onClick }) => (
    <button type="button" className={`nav-button ${active ? 'active' : ''}`} onClick={onClick}>
        <span className="nav-icon" aria-hidden="true">{icon}</span>
        <span>{label}</span>
    </button>
);

const Sidebar = ({ userInfo, openRegistrationPopup, handleNav, handleLogOut }) => {
    const { pathname } = useLocation();
    const initials = `${userInfo?.firstName?.[0] || ''}${userInfo?.lastName?.[0] || ''}` || 'QF';

    return (
        <aside className="sidebar">
            <div>
                <div className="sidebar-brand">
                    <span className="brand-mark">QF</span>
                    <div><strong>Quik Fix</strong><small>Employee Stats</small></div>
                </div>
                <nav className="nav" aria-label="Primary navigation">
                    <NavButton active={pathname === '/dashboard'} icon="⌂" label="Overview" onClick={() => handleNav('/dashboard')} />
                    <NavButton active={pathname === '/employees'} icon="▦" label="Employees" onClick={() => handleNav('/employees')} />
                    {userInfo?.manager && <NavButton active={pathname === '/managers'} icon="◫" label="Managers" onClick={() => handleNav('/managers')} />}
                    {userInfo?.manager && userInfo?.locationsEnabled && <NavButton active={pathname === '/locations'} icon="⌖" label="Locations" onClick={() => handleNav('/locations')} />}
                </nav>
            </div>
            <div className="sidebar-footer">
                {userInfo && (
                    <button type="button" className="user-info" onClick={openRegistrationPopup}>
                        <span className="user-avatar" aria-hidden="true">{initials}</span>
                        <span className="user-copy"><strong>{userInfo.firstName} {userInfo.lastName}</strong><small>Edit profile</small></span>
                    </button>
                )}
                <button type="button" className="out" onClick={handleLogOut}>Sign out</button>
            </div>
        </aside>
    );
};

export default Sidebar;
